import ChangePasswordMenu from './ChangePasswordMenu';
import DashboardMenu from './DashboardMenu';
import GroupListMenu from './GroupListMenu';
import VisitorListMenu from './VisitorListMenu';
//total menu list
const menuItem = {
    items: [DashboardMenu, GroupListMenu, VisitorListMenu, ChangePasswordMenu]
};
export default menuItem;
